<template>
    <div class="questionElement columnContainer absoluteCenter">
        <h1>{{ nom.index }}/{{ $route.params.nombreDeQuestions }}</h1>
        <div class="rowContainer">
            <h1>{{ nom.arabe }} </h1>
            <h2 style="margin-left: 10px;">- {{ nom.phonetique }}</h2>
        </div>
        <audio style="margin-bottom: 10px;" controls>
            <source :src="createAudioUrl(nom.audio)" type="audio/mpeg">//////
            Your browser does not support the audio element.
        </audio>
        <h2>Quelle est la traduction ?</h2>
        <input type="text" v-model="reponse" class="inputText marg">
        <div class="rowContainer">
            <button type="button" class="btn btn-warning marg" @click="displayVerifText">Vérifier</button>
            <button type="submit" class="btn btn-danger marg" @click="displayReponse">Réponse</button>
        </div>
        <h5 v-if="isVerifText"><b>{{ verifText }}</b></h5>
    </div>
</template>

<script>
export default {
    name: 'QuestionElement',
    props: {
        nomProp: Object
    },
    data() {
        return {
            nom: this.nomProp,
            reponse: "",
            isVerifText: false,
            verifText: "",
            backgroundColor: "",
        }
    },
    methods: {/////emits bonn ou maivaise reponse et recup dans question box et changement du background color
        createAudioUrl(url) {
            return require('../assets/audio/' + url)
        },
        compareTwoStrings(first, second) {
            first = first.replace(/\s+/g, '')
            second = second.replace(/\s+/g, '')

            if (first === second) return 1; // identical or empty
            if (first.length < 2 || second.length < 2) return 0; // if either is a 0-letter or 1-letter string

            let firstBigrams = new Map();
            for (let i = 0; i < first.length - 1; i++) {
                const bigram = first.substring(i, i + 2);
                const count = firstBigrams.has(bigram)
                    ? firstBigrams.get(bigram) + 1
                    : 1;

                firstBigrams.set(bigram, count);
            }

            let intersectionSize = 0;
            for (let i = 0; i < second.length - 1; i++) {
                const bigram = second.substring(i, i + 2);
                const count = firstBigrams.has(bigram)
                    ? firstBigrams.get(bigram)
                    : 0;

                if (count > 0) {
                    firstBigrams.set(bigram, count - 1);
                    intersectionSize++;
                }
            }

            return (2.0 * intersectionSize) / (first.length + second.length - 2);
        },
        displayVerifText() {
            this.isVerifText = true;

            let bonneReponse = false;

            this.nom.reponse = this.reponse

            this.nom.francais.forEach(traduction => {
                if (this.compareTwoStrings(traduction.toLowerCase(), this.reponse.toLowerCase()) > 0.75) {
                    this.verifText = "C'est la bonne réponse !"
                    bonneReponse = true;

                    this.nom.color = {
                        backgroundColor: "green"
                    }
                }
            });

            if (bonneReponse) {
                this.$emit("color", "green");
            } else {
                this.$emit("color", "red");
                this.verifText = "Ce n'est pas la bonne réponse"
                this.nom.color = {
                    backgroundColor: "red"
                }
            }

            this.$emit("id", this.nom.id);
            this.$emit("reponse", this.reponse);
        },
        displayReponse() {
            this.isVerifText = true;
            this.nom.showReponse = true

            this.verifText = "La traduction est : ";

            this.nom.francais.forEach(traduction => {
                this.verifText += traduction + " / ";
            });

            this.verifText = this.verifText.slice(0, -2);

            this.$emit("color", "rgb(47, 114, 129)");
            this.nom.color = {
                backgroundColor: "rgb(47, 114, 129)"
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.questionElement {
    text-align: center;
}

.columnContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.rowContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.marg {
    margin: 5px;
}

.btn {
    width: 150px;
}

.inputText {
    width: 300px;
    background-color: rgb(255, 255, 255);
    border-radius: 5px;
}

.absoluteCenter {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
